import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ChangePolicyModal = ({ show, onClose, username, currentPolicy, onSubmit }) => {
  const [newPolicy, setNewPolicy] = useState(currentPolicy || "readwrite");

  const handleSubmit = () => {
    if (!newPolicy) return;
    onSubmit(newPolicy);
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Alterar Permissões: {username}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Nova Política</Form.Label>
            <Form.Select value={newPolicy} onChange={(e) => setNewPolicy(e.target.value)}>
              <option value="readwrite">readwrite</option>
              <option value="readonly">readonly</option>
              <option value="writeonly">writeonly</option>
              <option value="consoleAdmin">consoleAdmin</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancelar</Button>
        <Button variant="primary" onClick={handleSubmit}>Salvar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePolicyModal;
